import React from 'react';
import { Hero } from './Hero';
import { PainPoints } from './PainPoints';
import { ForYouSection } from './ForYouSection';
import { ModulesSection } from './ModulesSection';
import { SevenDayPlanSection } from './SevenDayPlanSection';
import { BonusSection } from './BonusSection';
import { ProductSection } from './ProductSection';
import { TrustCTA } from './TrustCTA';
import { Testimonials } from './Testimonials';
import { DoubtSection } from './DoubtSection';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-[#FFFDF8] overflow-x-hidden" data-id="element-119">
      <Hero data-id="element-120" />
      <PainPoints data-id="element-121" />
      <ForYouSection data-id="element-122" />
      <ModulesSection data-id="element-123" />
      <SevenDayPlanSection data-id="element-124" />
      <BonusSection data-id="element-125" />
      <ProductSection data-id="element-126" />
      <TrustCTA data-id="element-127" />
      <Testimonials data-id="element-128" />
      <DoubtSection data-id="element-129" />
      <FAQ data-id="element-130" />
      <Footer data-id="element-131" />
    </div>;
}